import Stack from '@mui/material/Stack';
import Chip from '@mui/material/Chip';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import LinkIcon from '@mui/icons-material/Link';
import { notify } from './Notifier';

interface TicketCodeBadgeProps {
  ticketCode: string | null;
  /** Đường dẫn tuyệt đối tới trang chi tiết, vd "/bugs/ABC-B-0042" — dùng để sao chép link. */
  path: string;
}

async function copyToClipboard(text: string, successMessage: string): Promise<void> {
  try {
    await navigator.clipboard.writeText(text);
    notify(successMessage, 'success');
  } catch {
    notify('Không thể sao chép, vui lòng thử lại', 'error');
  }
}

/** Hiện mã ticket + nút sao chép mã/link. Project chưa gắn mã → hiện nhãn trung tính. */
export function TicketCodeBadge({ ticketCode, path }: TicketCodeBadgeProps): JSX.Element {
  if (!ticketCode) {
    return <Chip label="Chưa có mã dự án" size="small" variant="outlined" />;
  }
  return (
    <Stack direction="row" spacing={0.5} alignItems="center">
      <Chip label={ticketCode} size="small" variant="outlined" sx={{ fontFamily: 'monospace' }} />
      <Tooltip title="Sao chép mã">
        <IconButton size="small" onClick={() => void copyToClipboard(ticketCode, 'Đã sao chép mã')}>
          <ContentCopyIcon fontSize="inherit" />
        </IconButton>
      </Tooltip>
      <Tooltip title="Sao chép link">
        <IconButton
          size="small"
          onClick={() => void copyToClipboard(`${window.location.origin}${path}`, 'Đã sao chép link')}
        >
          <LinkIcon fontSize="inherit" />
        </IconButton>
      </Tooltip>
    </Stack>
  );
}
